import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import { LevStandardQueryMeta } from '../../../web/ReactQueryProvider';
import { timeEntryKeys } from './keys';
import { ITimeEntryFilter, ITimeEntryFilterOptions } from './types';

export function useTimeEntryFilterOptionsQuery({
	filter,
	enabled = true,
}: {
	filter: ITimeEntryFilter;
	enabled?: boolean;
}) {
	const userSession = useUserSession();
	return useQuery({
		queryKey: timeEntryKeys.filterOptions(filter),
		queryFn: () =>
			userSession.webServiceHelper.callAsync<ITimeEntryFilterOptions>('TimeEntry/filterOptions', 'POST', filter),
		enabled,
		// A pick changes the filter; keeping the last choices while the new ones load stops the select losing its value.
		placeholderData: keepPreviousData,
		meta: {
			toastErrorMessage: 'Failed to load filter options',
			errorLogging: { action: 'useTimeEntryFilterOptionsQuery', category: 'TimeEntry' },
		} satisfies LevStandardQueryMeta,
	});
}
